module.exports = __webpack_public_path__ + "static/2front-marketing-1-d55abc58eed9ba858790f44dcc6d0735.png";